<!-- SRD Tooltip Template -->
<ng-template #srdTooltipTemplate>
  <div [innerHTML]="constants.STOCK_REQUIRED_DATE_TOOLTIP"></div>
</ng-template>

<div [class]="isLoading?'page-loader':'page-loder d-none'"></div>
<form [formGroup]="deliveryDetailForm"
      (ngSubmit)="dateType === constants.SCD_HISTORY_TYPE ? onSubmitScd() : (isFromQuoteProduct ? updateStockRequiredDate() : onSubmit())"
      id="trade-register-form"
      (keydown.enter)="$event.preventDefault()">
    <div class="modal-header">
        <h4 class="modal-title">
            @if (dateType === constants.SCD_HISTORY_TYPE) {
                Update Storage Fees Commencement Date (SFCD)
            } @else {
                Update Stock Required Date (SRD)
            }
        </h4>
    </div>
    <div class="modal-body">
        <div class="modal-body-inner">
            <div class="add-user-form stock-required-date-container">

                <div class="row">
                    <div class="col quotes-active-inner">

                        @if (dateType === constants.SCD_HISTORY_TYPE) {
                            <!-- SCD date picker -->
                            <div class="form-field form-group">
                                <label class="grey-label">Storage Fees Commencement Date (SFCD) <span
                                    class="required-field">*</span></label>
                                <div class="input-group">
                                    <input bsDatepicker placement="auto"
                                           [bsConfig]="{ containerClass: 'theme-default', isAnimated: true, dateInputFormat: 'DD/MM/YYYY', showWeekNumbers: false }"
                                           formControlName="storage_commencement_date"
                                           class="form-control contactrdate"
                                           placeholder="Select storage fees commencement date"
                                           (keypress)="$event.preventDefault()"
                                           (keydown.enter)="$event.preventDefault()"
                                           type="text" autocomplete="off"
                                           [ngClass]="{ 'is-invalid': (deliveryDetailForm?.controls['storage_commencement_date']?.invalid && deliveryDetailForm?.controls['storage_commencement_date']?.touched || submitted), 'is-valid': !(deliveryDetailForm?.controls['storage_commencement_date']?.invalid) }">
                                    <img src="{{constants.S3_BUCKET_URL}}/calendar-icon-inner.svg" alt="icon"
                                         (error)="helperServices.getErrorImage($event)">
                                </div>
                                <span class="invalid-feedback d-block" role="alert"
                                      *ngIf="deliveryDetailForm.controls['storage_commencement_date']?.invalid && (deliveryDetailForm.controls['storage_commencement_date']?.touched || submitted)">
                  <span *ngIf="deliveryDetailForm.controls['storage_commencement_date']?.errors?.required">Select storage fees commencement date.</span>
                </span>
                            </div>

                            <!-- GC-339 Phase 1: manual (admin-fixed) storage fee. Order-level; overrides all accrual. -->
                            @if (level === 'quote') {
                            <br/>
                            <div class="email-selection-widget custom-label-checkbox">
                                <!-- GC-339: guidance for when the manual fee can be entered (SFCD set + reached,
                                     order not despatched) is shown via the info "i" icon beside the label.
                                     The disabled (not-allowed) cursor is applied ONLY to the checkbox itself when
                                     it can't be toggled — the label keeps its normal cursor. -->
                                <input type="checkbox" id="enter-manual-storage-fee"
                                       formControlName="is_manual_storage_fee"
                                       [class.cursor-not-allowed]="!canToggleManualFee"/>
                                <label class="checkbox-custom" for="enter-manual-storage-fee">Enter manual storage fees</label>
                                <img src="/assets/admin/images/info-circle-icon.svg" width="16" height="16"
                                     alt="info-icon" class="cursor-pointer manual-fee-info-icon"
                                     [container]="'body'" [placement]="'auto'" [triggers]="'hover'"
                                     [containerClass]="!canToggleManualFee ? 'manual-fee-warning-tooltip' : ''"
                                     [tooltip]="!canToggleManualFee ? manualFeeDisabledReason : 'Set a fixed (admin-entered) storage fee for this order. This overrides the automatic storage-fee accrual.'"
                                     (error)="helperServices.getErrorImage($event)"/>
                                <!-- GC-339: manual storage-fee history (activity type 100). Accessible
                                     regardless of the checkbox state — mirrors the SFCD history clock button. -->
                                <button type="button" class="icon-btn ms-5" (click)="openManualStorageFeeHistoryModal()"
                                        [container]="'body'" [placement]="'left'" [tooltip]="'Manual storage fee history'" [triggers]="'hover'">
                                    <img src="/assets/admin/images/time-icon.svg" width="18" height="18"
                                         alt="history-icon" (error)="helperServices.getErrorImage($event)"/>
                                </button>
                            </div>

                            @if (deliveryDetailForm.get('is_manual_storage_fee')?.value) {
                            <div class="form-field form-group">
                                <label class="grey-label">Manual Storage Fee <small>(Ex.GST)</small> <span
                                    class="required-field">*</span></label>
                                <input type="number" min="0.01" step="0.01"
                                       formControlName="manual_storage_fee_amount"
                                       class="form-control"
                                       placeholder="Enter manual storage fee amount"
                                       [ngClass]="{ 'is-invalid': (deliveryDetailForm?.controls['manual_storage_fee_amount']?.invalid && (deliveryDetailForm?.controls['manual_storage_fee_amount']?.touched || submitted)), 'is-valid': !(deliveryDetailForm?.controls['manual_storage_fee_amount']?.invalid) }">
                                <span class="invalid-feedback d-block" role="alert"
                                      *ngIf="deliveryDetailForm.controls['manual_storage_fee_amount']?.invalid && (deliveryDetailForm.controls['manual_storage_fee_amount']?.touched || submitted)">
                                    <span *ngIf="deliveryDetailForm.controls['manual_storage_fee_amount']?.errors?.required">Enter a manual storage fee amount.</span>
                                    <span *ngIf="deliveryDetailForm.controls['manual_storage_fee_amount']?.errors?.min">Amount must be greater than zero.</span>
                                </span>
                            </div>
                            }
                            }
                        } @else {
                            <!-- SRD date picker (existing) -->
                            <div class="form-field form-group">
                                <label class="grey-label">
                                    <span class="srd-label-inner">
                                    Stock Required Date (SRD)
                                    <img src="/assets/admin/images/info-circle-icon.svg"
                                         width="16"
                                         height="16"
                                         alt="info-icon"
                                         class="cursor-pointer ms-1"
                                         [tooltip]="srdTooltipTemplate"
                                         contentType="template"
                                         container="body"
                                         placement="auto" />
                                    <span class="required-field">*</span>
                                    </span>
                                </label>
                                <div class="input-group">
                                    <input #dp="bsDatepicker"
                                           [bsConfig]="{ containerClass: 'theme-default',isAnimated: true, dateInputFormat: 'DD/MM/YYYY', showWeekNumbers:false, minDate:minDate, isDisabled: (modelOrder.is_split_delivery && is_split_delivery) }"
                                           formControlName="stock_required_date" bsDatepicker placement="auto"
                                           class="form-control contactrdate" placeholder="Select stock required date"
                                           (keypress)="$event.preventDefault()"
                                           (keydown.enter)="$event.preventDefault()"
                                           type="text" autocomplete="off"
                                           [dateCustomClasses]="displayWarehouseArrivalDate"
                                           [ngClass]="{ 'is-invalid': (submitted && deliveryDetailForm?.controls['stock_required_date']?.invalid) || da?.stock_required_date?.errors?.apiError, 'is-valid' : submitted && !(deliveryDetailForm?.controls['stock_required_date']?.invalid)}">
                                    <img src="{{constants.S3_BUCKET_URL}}/calendar-icon-inner.svg" alt="icon"
                                         (error)="helperServices.getErrorImage($event)">
                                </div>
                                <span class="invalid-feedback d-block" role="alert"
                                      *ngIf="(submitted && deliveryDetailForm.controls['stock_required_date'].invalid) || da.stock_required_date.errors?.apiError">
                    <span *ngIf="da.stock_required_date.errors?.required">Select stock required date.</span>
                    <span
                        *ngIf="da.stock_required_date.errors?.apiError">{{ da.stock_required_date.errors?.apiError }}</span>
                </span>
                                @if (calculatedLeadTimeDate) {
                                    <div class="lead-time-info">
                                        Calculated Lead Time Date: <strong>{{ calculatedLeadTimeDate | date:'dd/MM/yyyy' }}</strong>
                                    </div>
                                }
                                @if (dateType !== constants.SCD_HISTORY_TYPE && !isFromQuoteProduct && !isFromQuoteEdit) {
                                    <div class="note-message">
                                        <span class="dot warehouse-arrival-date"></span>
                                        <span>Warehouse Arrival Date</span>
                                    </div>
                                    <div class="note-message">
                                        <strong>Note:</strong> You cannot select a date before the warehouse arrival
                                        date.
                                    </div>
                                }
                                @if (dateType !== constants.SCD_HISTORY_TYPE && !isFromQuoteProduct && !isFromQuoteEdit) {
                                    <div class="email-selection-widget"
                                         *ngIf="modelOrder?.stock_required_date && modelOrder.type === constants.ORDER_TYPE_ORDER_SHORT && modelOrder?.is_split_delivery"
                                         [ngClass]="{'stock-date-container' : !modelOrder?.stock_required_date}">
                                        <a (click)="onClickToRedirectCalendarView();$event.stopImmediatePropagation()"><i
                                            class="fal fa-link"></i>Open this order in calendar view</a>
                                    </div>
                                }
                            </div>
                        }



                        <div class="form-field form-group">
                            <label class="grey-label">Note <span class="required-field"
                                                                 *ngIf="isdateChanged">*</span></label>
                            <textarea class="form-control textarea-costume"
                                      formControlName="note"
                                      placeholder="Enter note here"
                                      rows="4"
                                      [ngClass]="{ 'is-invalid': (da.note?.invalid && (da.note?.touched || submitted)), 'is-valid': !(da.note?.invalid) }"></textarea>
                            <span class="invalid-feedback d-block" role="alert"
                                  *ngIf="da.note?.invalid && (da.note?.touched || submitted)">
                <span *ngIf="da.note?.errors?.required">Enter a note.</span>
              </span>
                        </div>

                        @if (dateType !== constants.SCD_HISTORY_TYPE && !isFromQuoteEdit && !is_split_delivery && showSfcdCheckbox) {
                            <br/>
                            <div class="email-selection-widget custom-label-checkbox">
                                <input type="checkbox" id="update-sfcd" formControlName="update_sfcd"/>
                                <label class="checkbox-custom" for="update-sfcd">Sync Storage Fees Commencement Date(SFCD) with SRD</label>
                            </div>
                        }

                        @if (dateType !== constants.SCD_HISTORY_TYPE && !isFromQuoteProduct && !isFromQuoteEdit && modelOrder.show_split_delivery_option && !isSplitDeliveryDisabled && !modelOrder?.is_consumable_order) {
                            <br/>
                            <div class="email-selection-widget custom-label-checkbox">
                                <input type="checkbox" id="split-delivery" data-md-icheck (change)="onChange($event)"
                                       [checked]="is_split_delivery"/>
                                <label class="checkbox-custom" for="split-delivery">Split Delivery</label>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="dark-bordered-btn dont-send-btn" data-dismiss="modal" (click)="cancel()">Cancel
        </button>
        <button type="submit" class="submit-btn-grey status-modal-save">Update</button>
    </div>
</form>
